import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip);

const COLORS = [
  '#FF6B35', '#FFC107', '#4CAF50', '#2196F3',
  '#9C27B0', '#FF5722', '#00BCD4', '#795548', '#E91E63',
  '#3F51B5', '#009688', '#CDDC39', '#FF5252', '#40C4FF',
  '#69F0AE', '#EA80FC', '#FFD180', '#FF6E40', '#B0BEC5',
];

const OPTIONS = {
  plugins: { legend: { display: false } },
};

function DonutCard({ title, data, loading, error, colors, colorMap }) {
  if (loading) {
    return (
      <div className="tl-card">
        <h3 className="tl-card__title">{title}</h3>
        <div className="tl-card__placeholder">Loading…</div>
      </div>
    );
  }
  if (error || !data || data.length === 0) {
    return (
      <div className="tl-card">
        <h3 className="tl-card__title">{title}</h3>
        <div className="tl-card__placeholder">No data</div>
      </div>
    );
  }

  const palette = data.map((d, i) => {
    if (colorMap && colorMap[d.label]) return colorMap[d.label];
    if (colors && colors[i]) return colors[i];
    return COLORS[i % COLORS.length];
  });

  const chartData = {
    labels: data.map((d) => d.label),
    datasets: [
      {
        data: data.map((d) => d.value),
        backgroundColor: palette,
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="tl-card tl-donut-card">
      <h3 className="tl-card__title">{title}</h3>
      <div className="tl-donut-body">
        <div className="tl-donut-chart">
          <Doughnut data={chartData} options={OPTIONS} />
        </div>
        <ul className="tl-donut-legend">
          {data.map((d, i) => (
            <li key={d.label} className="tl-donut-legend__item">
              <span
                className="tl-donut-legend__swatch"
                style={{ background: palette[i] }}
              />
              <span className="tl-donut-legend__label">{d.label}</span>
              <span className="tl-donut-legend__value">{Math.round(d.value)}%</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default DonutCard;
